import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';
import { formatCellValue, TableColumn } from '@app/model';

/** Formats a table cell, see `formatCellValue`. */
@Pipe({
  name: 'cellFormat',
  standalone: false,
})
export class CellFormatPipe implements PipeTransform {
  private locale = inject(LOCALE_ID);

  transform(
    value: unknown,
    column: Pick<TableColumn, 'dataType' | 'format'>
  ): string {
    return formatCellValue(value, column, this.locale);
  }
}
